import { render, staticRenderFns } from "./pinklist.vue?vue&type=template&id=33709e9d&scoped=true&"
import script from "./pinklist.vue?vue&type=script&lang=js&"
export * from "./pinklist.vue?vue&type=script&lang=js&"
import style0 from "./pinklist.vue?vue&type=style&index=0&id=33709e9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33709e9d",
  null
  
)

export default component.exports